export interface CustomFieldsForTaskProcessPage {
  user: CustomField[];
  conversation: CustomField[];
}

export interface CustomField {
  value: CustomFieldValue;
  definition: CustomFieldDefinition;
  isEditable: boolean;
}

export type CustomFieldValue = number | string | CustomFieldPhoneNumber;

export interface CustomFieldDefinition {
  id: number;
  type: CustomFieldTypeDefinition;
  label: string;
  description: string;
  scope: CustomFieldOwnerType;
  standard_field_id?: number;
}

export interface CustomFieldTypeDefinition {
  type: CustomFieldTypeName;
  default: CustomFieldValue;
  can_set_null: boolean;
  allowed?: CustomFieldAllowedValue[]; // only if type is Enumerate or Multipicklist
}

export interface CustomFieldAllowedValue {
  id: string;
  label: string;
}

export interface CustomFieldPhoneNumber {
  countryCode: string;
  phoneNumber: string;
}

// called 'scope' in API
export enum CustomFieldOwnerType {
  Conversation = 'conversation',
  User = 'user',
}

// called 'view' in API
export enum CustomFieldDisplayContext {
  Inbox = 'inbox',
  Profile = 'profile',
  SearchSelector = 'search-selector',
  SearchResult = 'search-result',
}

export enum CustomFieldTypeName {
  Integer = 'integer',
  Float = 'float',
  String = 'string',
  Boolean = 'boolean',
  Enumerate = 'enum',
  Multipicklist = 'multipicklist',
  URL = 'url',
  Phone = 'phone',
  Email = 'email',
  Datetime = 'datetime',
  Date = 'date',
}

export type FieldIdsForEditableContextResponse = {
  id: number;
  is_editable: boolean;
}[];

export type FieldValuesReponse = {
  field_id: number;
  field_value: CustomFieldValue;
}[];
